import React from 'react'
import { Button, Divider, Modal } from "antd";
import { MdContentCopy } from "react-icons/md";
import SwalToast from '../../../../components/helpers/SwalToast';

export default function ModalOngoingVa({ visible, handleClose, data, loading, onRefresh }) {
    console.log('va',data)
    const copyToClipbord = (VA) => {
        navigator.clipboard.writeText(VA)
        SwalToast.fire({
            icon: "success",
            title: 'Nomor Virtual Account berhasil di copy',
        });
    }

    return (
        <Modal
            title={"Nomor VA yang Diterbitkan"}
            visible={visible}
            onCancel={handleClose}
            width={600}
            centered
            footer={[
                <Button
                    key="back"
                    onClick={handleClose}
                    className="btn-modal btn-default"
                    style={{ width: "15%" }}
                >
                    Tutup
                </Button>,
                <Button
                    disabled={loading}
                    key="submit"
                    type="primary"
                    onClick={onRefresh}
                    className="btn-modal"
                    style={{ width: "15%" }}
                >
                    Refresh
                </Button>,
            ]}
        >
            <div className="py-2">
                {
                    data?.transaction?.map((item, index) => {
                        return (
                            <div key={index}>
                                <div className='row justify-content-between my-2'>
                                    <div className='col-5' style={{ color: '#A6A6A6' }}>Tanggal/Waktu :</div>
                                    <div className='col-7' style={{ fontSize: 14, color: '#303030' }}>{item.date}</div>
                                </div>
                                <div className='row justify-content-between my-2'>
                                    <div className='col-5' style={{ color: '#A6A6A6' }}>No. SBG :</div>
                                    <div className='col-7' style={{ fontSize: 14, color: '#303030' }}>{data.sbg}</div>
                                </div>
                                <div className='row justify-content-between my-2'>
                                    <div className='col-5' style={{ color: '#A6A6A6' }}>No. Kwitansi :</div>
                                    <div className='col-7' style={{ fontSize: 14, color: '#303030' }}>{item.receipt}</div>
                                </div>
                                <div className='row justify-content-between my-2'>
                                    <div className='col-5' style={{ color: '#A6A6A6' }}>Nama Nasabah :</div>
                                    <div className='col-7' style={{ fontSize: 14, color: '#303030' }}>{data.customerName}</div>
                                </div>
                                <div className='row justify-content-between my-2'>
                                    <div className='col-5' style={{ color: '#A6A6A6' }}>Tujuan Pembayaran :</div>
                                    <div className='col-7' style={{ fontSize: 14, color: '#303030' }}>Cicilan {item.periodNumber}</div>
                                </div>
                                <div className='row justify-content-between my-2'>
                                    <div className='col-5' style={{ color: '#A6A6A6' }}>Bank:</div>
                                    <div className='col-7' style={{ fontSize: 14, color: '#303030' }}>{item.bank?.toUpperCase()}</div>
                                </div>
                                <div className='row justify-content-between my-2'>
                                    <div className='col-5' style={{ color: '#A6A6A6' }}>Total Pembayaran :</div>
                                    <div className='col-7' style={{ fontSize: 14, color: '#303030', fontWeight: '700', fontSize: 16 }}>{item.totalPayment}</div>
                                </div>
                                <div className='row justify-content-between my-2'>
                                    <div className='col-5' style={{ color: '#A6A6A6' }}>Nomor VA :</div>
                                    <div className='d-flex col-7'>
                                        <div className='' style={{ fontSize: 14, color: '#303030', fontWeight: '700', fontSize: 16 }}>{item.va}</div>
                                        <MdContentCopy onClick={() => copyToClipbord(item.va)} className='ml-2' size={24} style={{ color: "#2C465C", cursor: "pointer" }} />
                                    </div>
                                </div>
                                {index !== data?.transaction.length - 1 && <Divider className='mb-3' />}
                            </div>
                        )
                    })
                }
            </div>
        </Modal>
    )
}
